import SelectorEngine from '../../utils/dom/selector-engine';
import Request, { ApiMode } from '../../utils/request';

const IS_LOCAL = false;
const SELECTOR_LINKED_CHILD = '.p-account-details__linked-child-accounts';
const SELECTOR_EDIT_CHILD_BUTTON = '.p-account-details__linked-child-accounts-edit-button';

const HIDDEN_CLASS = 'u-hidden';
class AccountDetails {
	constructor() {
		this._accountWrapper = undefined;
		this.initiateAccountDetails();
	}

	get playersData() {
		return this._playersData;
	}
	set playersData(data) {
		this._playersData = data;
		if(this._playersData.length > 0) {
			this.renderPlayerList(data);
		}
	}
	initiateAccountDetails() {
		this._accountWrapper = document.querySelector('.p-account-details');
		if(!this._accountWrapper){
			return;
		}
		this.linkedChildAccount = SelectorEngine.findOne(SELECTOR_LINKED_CHILD, this._accountWrapper);
		this.editChildAccount = SelectorEngine.findOne(SELECTOR_EDIT_CHILD_BUTTON, this._accountWrapper);

		const updateButtons = this._accountWrapper.querySelectorAll('.js-update-button');

		updateButtons.forEach((button) => {
			button.addEventListener('click', (event) => {
				const rootUrl = window.location.origin
				const targetUrl = event.target.dataset.target;

				if(!targetUrl){
					return;
				}
				window.location.href = rootUrl + targetUrl;
			});
		});
		this.fetchPlayersList();
	}

	async fetchPlayersList() {
		try { 
			const url = `/api/player/getplayers`;
			const response = await Request.get(url, {}, {
				local: IS_LOCAL,
				req: {
					apiMode: ApiMode.LtaError
				}
			});
			const { playerDetails, error } = response;
			if(playerDetails) {
				this.playersData = [...playerDetails];
			} else {
				this.editChildAccount.classList.add(HIDDEN_CLASS);
			}

			if (!!error?.hasError) {
				throw error;
			}
		} catch (error) {
			this.editChildAccount.classList.add(HIDDEN_CLASS);
			if (error.hasError) {
				console.log("Error : ", error);
			}
		}
	}
	renderPlayerList(playerData) {
		this.linkedChildAccount.innerHTML = this.renderTable(playerData);
	}
	renderTable(playerData) {
		const playerListData = playerData.map((item, index) => this.renderTableData(item, index)).join('');
		return `
			<table class="lta-table__small-table">
				<tbody>
					${playerListData}
				</tbody>
			</table>`;
	}
	renderTableData(playerItem, index) {
		return `
			<tr>
				<th class="u-body2 u-text-left">Child ${index + 1}</th>
				<td class="u-h6 u-text-right">${playerItem.firstName} ${playerItem.lastName}</td>
			</tr>
		`;
	}
}

const globalAccountDetails = new AccountDetails();
export default globalAccountDetails;
